import { useMemo } from "react";

export default function useAnimationOverride() {
  return useMemo(() => {
    if (typeof window === "undefined") return null;
    const params = new URLSearchParams(window.location.search);
    const val = params.get("anim");
    if (val === "1" || val === "true") return true;
    if (val === "0" || val === "false") return false;
    return null;
  }, []);
}
